/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseMetaNotificationConfig } from '../../models/api-response-meta-notification-config';
import { MetaNotificationConfig } from '../../models/meta-notification-config';

export interface UpdateConfig$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: MetaNotificationConfig
}

export function updateConfig(http: HttpClient, rootUrl: string, params: UpdateConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseMetaNotificationConfig>> {
  const rb = new RequestBuilder(rootUrl, updateConfig.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseMetaNotificationConfig>;
    })
  );
}

updateConfig.PATH = '/v1/api/ui/meta-notification/config';
